/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
export default {
  name: 'about-of-user-info',
  components: {
    Multiselect,
    datetime: Datetime,
  },
  props: [
  ],
  data () {
    return {
      submitted:false,
      professionLabel:[
        {name:'Medical oncologist', code:'Medical oncologist'},
        {name:'Clinical Oncologist', code:'Clinical Oncologist'},
        {name:'Cardiologist', code:'Cardiologist'},
        {name:'Surgeon', code:'Surgeon'},
        {name:'Medical Physicist', code:'Medical Physicist'},
        {name:'Other Medical Professional', code:'Other Medical Professional'},
        {name:'Medical AI Engineer', code:'Medical AI Engineer'},
        {name:'Other Professional', code:'Other Professional'},
      ],
      patientDiseasesLalbel:[
        {name:'Non-Hodgin’s Lymphoma', code:'Non-Hodgin’s Lymphoma'},
        {name:'ALL', code:'ALL'},
        {name:'AML', code:'AML'},
        {name:'Squamous Cell Carcinoma', code:'Squamous Cell Carcinoma'},
        {name:'Coronary artery bypass grafting', code:'Coronary artery bypass grafting'},
        {name:'neurosurgery', code:'neurosurgery'},
        {name:'Cardiovascular Surgery', code:'Cardiovascular Surgery'},
        {name:'COPD', code:'COPD'},
      ],
      clinicalIntersetLabel:[
        {name:'Primary Philadelphia chromosome positive acute myeloid leukaemia', code:'Primary Philadelphia chromosome positive acute myeloid leukaemia'},
        {name:'heterogeneous molecular grade of DLBCL with MYC', code:'heterogeneous molecular grade of DLBCL with MYC'},
        {name:'BCL2 double-hit', code:'BCL2 double-hit'},
        {name:'mucosal signet-ring cell carcinoma', code:'mucosal signet-ring cell carcinoma'}
      ],
      surgicalIntersetLabel:[
        {name:'Surgical Resection', code:'Surgical Resection'}
      ],
      researchAreasLabel:[
        {name:'Cancer Genetics & Genomics', code:'Cancer Genetics & Genomics'},
        {name:'Cancer Immunotherapy & Vaccines', code:'Cancer Immunotherapy & Vaccines'},
        {name:'Cancer Metabolism', code:'Cancer Metabolism'},
        {name:'Cell Signalling & Regulation', code:'Cell Signalling & Regulation'},
        {name:'Computational Oncology', code:'Computational Oncology'},
        {name:'Medical Machine Learning', code:'Medical Machine Learning'},
        {name:'Medical AI', code:'Medical AI'},
        {name:'Biomedical Engineering', code:'Biomedical Engineering'},
        {name:'AI', code:'AI'},
        {name:'ML', code:'ML'},
        {name:'Other', code:'Other'}
      ],
      workAssociatedLabel:[
        {name:'Memorial Sloan Kettering Hospital', code:'Memorial Sloan Kettering Hospital'},
        {name:'NYU Langone', code:'NYU Langone'},
        {name:'Tata Medical Centre', code:'Tata Medical Centre'},
        {name:'Centre for Disease Control (CDC)', code:'Centre for Disease Control (CDC)'}
      ],
      dgreeLabel:[
        {name:'MD', code:'MD'},
        {name:'Ph.D.', code:'Ph.D.'},
        {name:'M.D. & Ph.D.', code:'M.D. & Ph.D.'},
        {name:'M.S.', code:'M.S.'},
        {name:'M.Ch.', code:'M.Ch.'},
        {name:'MBBS', code:'MBBS'},
        {name:'DM', code:'DM'},
        {name:'DNB', code:'DNB'},
        {name:'M.Sc.', code:'M.Sc.'},
        {name:'MBA', code:'MBA'}
      ],
      availableDayLabel:[
        {name:'Monday', code:'Monday'},
        {name:'Tuesday', code:'Tuesday'},
        {name:'Wednesday', code:'Wednesday'},
        {name:'Thursday', code:'Thursday'},
        {name:'Friday', code:'Friday'},
        {name:'Saturday', code:'Saturday'},
        {name:'Sunday', code:'Sunday'}
      ],
      languageProficiencyLabel:[
        {name:'English', code:'English'},
        {name:'French', code:'French'},
        {name:'Hindi', code:'Hindi'},
        {name:'Mandarin', code:'Mandarin'},
        {name:'German', code:'German'},
        {name:'Japanese', code:'Japanese'},
        {name:'Korean', code:'Korean'},
        {name:'Italian', code:'Italian'},
        {name:'Cantonese', code:'Cantonese'},
        {name:'Spanish', code:'Spanish'},
        {name:'Bengali', code:'Bengali'},
        {name:'Tamil', code:'Tamil'},
        {name:'Gujrati', code:'Gujrati'},
        {name:'Marathi', code:'Marathi'},
        {name:'Telegu', code:'Telegu'},
        {name:'Malayalam', code:'Malayalam'},
        {name:'Punjabi', code:'Punjabi'},
        {name:'Thai', code:'Thai'},
        {name:'Hebrew', code:'Hebrew'},
        {name:'Arabic', code:'Arabic'},
        {name:'Swahili', code:'Swahili'},
        {name:'Amharic', code:'Amharic'},
        {name:'Russian', code:'Russian'},
        {name:'Bahasa', code:'Bahasa'},
        {name:'Malay', code:'Malay'},
        {name:'Portugese', code:'Portugese'},
      ],
      professionValue:{
        name:'',
        code:''
      },
      patientDiseasesValue:[],
      clinicalIntersetValue:{
        name:'',
        code:''
      },
      surgicalIntersetValue:{
        name:'',
        code:''
      },
      researchAreasValue:[],
      workAssociatedValue:{
        name:'',
        code:''
      },
      dgreeValue:{
        name:'',
        code:''
      },
      availableDayValue:[],
      availableDaySelectedArrValue:[],
      medicalProExperienceValue:[],
      languageProficiencyValue:[],
      sendResearchAreasValue:[],
      sendLanguageProficiencyValue:[],
      medicalProExperienceNamber:'',
      serviceFlag:false,
      selfUserInfoData:null,
      dr_prefix_checking:'',
      start_time:'',
      end_time:'',
      timeDiffValidation:true
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoMethod(){
      this.selfUserInfoData = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    setInitialStatesForPrefixMethod(){
      if(this.selfUserInfoData){
        this.dr_prefix_checking = this.selfUserInfoData.salutation 
      }
    }
  },
  mounted(){
    this.getSelfUserInfoMethod
    this.setInitialStatesForPrefixMethod
    this.$store.dispatch('getAboutDetailsOfProfileFun').then((res) => {
      this.professionValue.name = res.data.data.profession
      this.professionValue.code = res.data.data.profession
      this.dgreeValue.name = res.data.data.clinical_interest
      this.dgreeValue.code = res.data.data.clinical_interest
      this.serviceFlag = res.data.data.active
      this.clinicalIntersetValue = res.data.data.clinical_interest
      this.surgicalIntersetValue = res.data.data.surgical_interest
      this.workAssociatedValue = res.data.data.work_for
      this.medicalProExperienceNamber = res.data.data.experience
      this.patientDiseasesValue = res.data.data.treatment_diseases
      this.dgreeValue.name = res.data.data.degree
      this.dgreeValue.code = res.data.data.degree
      for(var i = 0; i < res.data.data.research_areas.length; i++){
        this.researchAreasValue.push({name:res.data.data.research_areas[i],code:res.data.data.research_areas[i]})
      }
      for(var i = 0; i < res.data.data.language.length; i++){
        this.languageProficiencyValue.push({name:res.data.data.language[i],code:res.data.data.language[i]})
      }
    })
  },
  methods: {
    getTimeDiffBtWStartandEndMethod(nowt, thent){
      var now  = moment(nowt).format('HH:mm:ss');
      var then = moment(thent).format('HH:mm:ss');
      var outputs = moment.utc(moment(then,"HH:mm:ss").diff(moment(now,"HH:mm:ss"))).format("HH:mm:ss")
      if(outputs > '03:59:59'){
        this.timeDiffValidation = false;
        return true;
      }else{
        this.timeDiffValidation = false;
        return false;
      }
    },
    addTagOfprofession (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.professionValue = []
      this.professionLabel.push(tag)
      this.professionValue.push(tag)
    },
    addTagOfResearchAreas (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.researchAreasLabel.push(tag)
      this.researchAreasValue.push(tag)
    },
    addTagOfDgree (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.dgreeValue = []
      this.dgreeLabel.push(tag)
      this.dgreeValue.push(tag)
    },
    addTagOfLanguageProficiency (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.medicalProExperienceLabel.push(tag)
      this.languageProficiencyValue.push(tag)
    },
    updateAboutBeforeSubmitMethod(){
      if(this.getTimeDiffBtWStartandEndMethod(this.start_time, this.end_time) == false){
        return;
      }
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var sendProfessionValue
          var sendDgreeValue
          for(var i = 0; i < this.researchAreasValue.length; i++){
            this.sendResearchAreasValue.push(this.researchAreasValue[i].name)
          }
          for(var i = 0; i < this.languageProficiencyValue.length; i++){
            this.sendLanguageProficiencyValue.push(this.languageProficiencyValue[i].name)
          }
          if(this.professionValue.name){
            sendProfessionValue = this.professionValue.name
          }else{
            sendProfessionValue = this.professionValue[0].name
          }
          if(this.dgreeValue.name){
            sendDgreeValue = this.dgreeValue.name
          }else{
            sendDgreeValue = this.dgreeValue[0].name
          }
          let data = {
            profession:sendProfessionValue,
            treatment_diseases:this.patientDiseasesValue,
            clinical_interest:this.clinicalIntersetValue,
            surgical_interest:this.surgicalIntersetValue,
            research_areas:JSON.stringify(this.sendResearchAreasValue),
            work_for:this.workAssociatedValue,
            degree:sendDgreeValue,
            experience:this.medicalProExperienceNamber,
            language:JSON.stringify(this.sendLanguageProficiencyValue),
            active:this.serviceFlag
           }
          this.$store.dispatch('updateAboutOfProfileFun', data)
            .then((res) => {  
              toast.success(res.data.msg);
              this.submitted =  false
              this.getAboutDetailForUserInfoMethod()
              this.closeUpdateAboutUserInfoPopup()
            }).catch((err) => {
              toast.error( err.data.user_msg || err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    closeUpdateAboutUserInfoPopup(){
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('aboutUserInfoPopupStateBus', false);
    },
    getAboutDetailForUserInfoMethod(){
    this.$store.dispatch('getAboutDetailsOfProfileFun')
    }
  },
  watch: {
    getSelfUserInfoMethod(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    setInitialStatesForPrefixMethod(){
      if(this.selfUserInfoData){

      }
    }
  },
}